export const PAYMENT_METHODS = [
    { id: 'pix', label: 'PIX' },
    { id: 'credit', label: 'Cartão de crédito' },
    { id: 'boleto', label: 'Boleto' },
    { id: 'debit', label: 'Cartão de débito' },
];

export const PAYMENT_METHOD_MAP = PAYMENT_METHODS.reduce((acc, m) => {
    acc[m.id] = m;
    return acc;
}, {});
